import { AxiosResponse } from 'axios';
import { SalaryDtos } from '../../../Model/Dto/Salaries';
import { axiosCoreInstance } from '../../AxiosCoreInterceptor';
import * as ApiUrls from './ApiUrl.Salary';

export const SalaryService = {
    GetIndividualSalariesForYears: (id: number): Promise<AxiosResponse<SalaryDtos.SalariesPerYearResponse[]>> =>
        axiosCoreInstance.get(ApiUrls.GetSalariesByIndividualIdForYears(id)),
    AddIndividualSalariesForYear: (id: number, year: number): Promise<AxiosResponse<SalaryDtos.SalariesPerYearResponse>> =>
        axiosCoreInstance.post(ApiUrls.AddSalariesByIndividualIdForYear(id, year)),
    SaveIndividualSalariesForYear: (id: number, data: SalaryDtos.SalariesPerYearResponse): Promise<AxiosResponse<string>> =>
        axiosCoreInstance.post(ApiUrls.SaveSalariesByIndividualIdForYear(id), data),
    DeleteIndividualSalariesForYear: (id: number, year: number): Promise<AxiosResponse<string>> =>
        axiosCoreInstance.delete(ApiUrls.DeleteSalariesByIndividualIdForYear(id, year)),
    Search: (searchInput: SalaryDtos.SearchRequest): Promise<AxiosResponse<SalaryDtos.SearchResponse>> =>
        axiosCoreInstance.post(ApiUrls.Search, searchInput)
}